/* Banner de cookies — Glucody (29-jul · Consent Mode v2 advanced 17-ago)

   Habla con DOS sistemas, y los dos son obligatorios:

   1) Customer Privacy API de Shopify — la fuente de verdad LEGAL. Gobierna los
      pixels de Shopify (analítica propia, canal de Google, Klaviyo…).
      CLAVE: Shopify NO carga sola esa API. Si el banner se limita a
      `if (!Shopify.customerPrivacy) return;` el visitante pulsa Aceptar, el
      banner se cierra y Shopify NO REGISTRA NADA: analytics y marketing siguen
      bloqueados aunque haya aceptado, y el consentimiento se pierde en silencio.
      Por eso pedimos la feature con Shopify.loadFeatures antes de escribir nada.

   2) Google Consent Mode v2 en modo ADVANCED — ver snippets/iurop-consent-mode.
      La etiqueta ya está cargada con todo denegado; aquí mandamos el
      `consent update` que la desbloquea. Sin este paso el modo advanced no
      sirve de nada: la etiqueta se quedaría denegada para siempre.

   Y una cookie espejo, `glucody_consent`, para que la próxima carga arranque ya
   con los permisos correctos ANTES de que cargue la etiqueta (los permisos por
   defecto se declaran de forma síncrona en el head y `_tracking_consent` no es
   legible desde document.cookie).

   Verificación (documentado, cuesta tiempo si no se sabe): la cookie
   `_tracking_consent` NO es visible desde document.cookie. El criterio válido es
   Shopify.customerPrivacy.currentVisitorConsent() / analyticsProcessingAllowed(),
   y para Google, dataLayer + el parámetro `gcs` de las peticiones. */
(function () {
  if (window.__glucodyCookiesLoaded) return;
  window.__glucodyCookiesLoaded = true;

  var ROOT = '[data-cookies]';
  var MIRROR = 'glucody_consent';
  var MIRROR_DAYS = 180;

  function withCustomerPrivacy(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return;
        if (window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
      });
    }
  }

  // ---- Cookie espejo (solo para arrancar con los permisos correctos) --------
  function readMirror() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)glucody_consent=([^;]*)/);
      return m ? JSON.parse(decodeURIComponent(m[1])) : null;
    } catch (e) { return null; }
  }

  function writeMirror(consent) {
    try {
      var v = encodeURIComponent(JSON.stringify({ a: !!consent.analytics, m: !!consent.marketing }));
      var exp = new Date(Date.now() + MIRROR_DAYS * 864e5).toUTCString();
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = MIRROR + '=' + v + '; Path=/; Expires=' + exp + '; SameSite=Lax' + secure;
    } catch (e) {}
  }

  function clearMirror() {
    try {
      document.cookie = MIRROR + '=; Path=/; Max-Age=0; SameSite=Lax';
    } catch (e) {}
  }

  // ---- Google Consent Mode v2 ----------------------------------------------
  // `forzar` = el visitante ACABA de decidir pulsando un botón. Ese update se
  // manda siempre, aunque el valor coincida con el que ya había por defecto:
  // para Google no es lo mismo "denegado porque nadie ha contestado" que
  // "denegado porque el usuario ha dicho que no", y es justo lo que pasaba al
  // pulsar Rechazar (los dos son 'denied' y la deduplicación se lo comía).
  // Sin `forzar` venimos de una reconciliación automática y ahí sí deduplicamos:
  // al aceptar llegamos por dos caminos (el botón y el evento
  // visitorConsentCollected que emite Shopify) y sería mandar dos veces lo mismo.
  function pushGtagConsent(consent, forzar) {
    if (typeof window.gtag !== 'function') return;
    var marketing = consent.marketing ? 'granted' : 'denied';
    var analytics = consent.analytics ? 'granted' : 'denied';

    var prev = window.__glucodyConsentState;
    if (!forzar && prev && prev.analytics === analytics && prev.marketing === marketing) return;

    window.gtag('consent', 'update', {
      ad_storage: marketing,
      ad_user_data: marketing,
      ad_personalization: marketing,
      personalization_storage: marketing,
      analytics_storage: analytics,
      functionality_storage: 'granted',
      security_storage: 'granted'
    });
    window.gtag('set', 'ads_data_redaction', marketing !== 'granted');
    window.__glucodyConsentState = { analytics: analytics, marketing: marketing };
  }

  // ¿Ya respondió el visitante? Si no hay respuesta guardada, se muestra el banner.
  function answeredConsent(cp) {
    try {
      var c = cp.currentVisitorConsent() || {};
      var known = function (v) { return v === 'yes' || v === 'no'; };
      if (!(known(c.analytics) || known(c.marketing) || known(c.preferences))) return null;
      return { analytics: c.analytics === 'yes', marketing: c.marketing === 'yes' };
    } catch (e) { return null; }
  }

  function init() {
    var root = document.querySelector(ROOT);
    if (!root || root.dataset.cookiesReady) return;
    root.dataset.cookiesReady = '1';

    var panel = root.querySelector('[data-cookies-prefs]');
    var chkAnalytics = root.querySelector('[data-cookies-analytics]');
    var chkMarketing = root.querySelector('[data-cookies-marketing]');

    // hideTimer: si el visitante REABRE desde el footer dentro de los 260ms de
    // la animación de cierre, el timeout pendiente ocultaba el banner recién
    // abierto (probado: quedaba oculto). Se cancela al mostrar.
    var hideTimer = null;
    var saving = false;

    function show() {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      saving = false;
      root.hidden = false;
      // La clase de apertura es la que sube la opacidad de 0 a 1. Se dejaba
      // SOLO en manos de requestAnimationFrame, y rAF no dispara en pestañas
      // que cargan en segundo plano: el banner se quedaba presente pero
      // invisible (medido: hidden=false, sin data-open, opacity 0). Si la
      // pestaña no está visible lo aplicamos en el acto, y además dejamos un
      // temporizador de respaldo. Poner el atributo dos veces es inocuo.
      if (document.visibilityState === 'visible') {
        requestAnimationFrame(function () { root.setAttribute('data-open', ''); });
      } else {
        root.setAttribute('data-open', '');
      }
      setTimeout(function () { if (!root.hidden) root.setAttribute('data-open', ''); }, 300);
      document.body.classList.add('has-cookie-banner');
    }
    function hide() {
      root.removeAttribute('data-open');
      document.body.classList.remove('has-cookie-banner');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { root.hidden = true; hideTimer = null; }, 260);
    }

    // El page_view de esta página ya salió con analytics_storage denegado
    // (gcs=G100). Google lo usa para modelar, pero NO cuenta como sesión. Si el
    // visitante acepta aquí y se marcha sin navegar, esa sesión no existe en
    // GA4: la medición no arranca hasta la SEGUNDA página. Reenviamos el
    // page_view una sola vez al conceder analítica.
    //
    // Condición imprescindible: solo si la etiqueta que mide es la NUESTRA
    // (__glucodyTagLoaded). Cuando mide el pixel de Shopify, el page_view es
    // suyo y reenviarlo aquí duplicaría la vista.
    var pageViewReenviado = false;
    function contarPaginaDeAceptacion() {
      if (pageViewReenviado) return;
      if (root.getAttribute('data-cookies-count-accept') === '0') return;
      if (!window.__glucodyTagLoaded) return;
      if (typeof window.gtag !== 'function') return;
      pageViewReenviado = true;
      window.gtag('event', 'page_view');
    }

    function save(consent) {
      // Guard anti doble-clic: 3 clics rápidos disparaban 3 llamadas a la API.
      if (saving) return;
      saving = true;

      // Google primero: es síncrono y no depende de que cargue nada. Así la
      // etiqueta queda desbloqueada aunque la API de Shopify tarde o falle.
      pushGtagConsent(consent, true);
      if (consent.analytics) contarPaginaDeAceptacion();
      writeMirror(consent);

      withCustomerPrivacy(function (cp) {
        try {
          cp.setTrackingConsent({
            analytics: !!consent.analytics,
            marketing: !!consent.marketing,
            preferences: !!consent.preferences,
            sale_of_data: !!consent.marketing
          }, function () {});
        } catch (e) {}
      });
      hide();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cookies-action]');
      if (!t) return;
      var a = t.getAttribute('data-cookies-action');
      if (a === 'accept') return save({ analytics: true, marketing: true, preferences: true });
      if (a === 'reject') return save({ analytics: false, marketing: false, preferences: false });
      if (a === 'prefs') {
        var open = panel.hasAttribute('data-open');
        if (open) { panel.removeAttribute('data-open'); panel.hidden = true; }
        else { panel.hidden = false; panel.setAttribute('data-open', ''); }
        t.setAttribute('aria-expanded', open ? 'false' : 'true');
        return;
      }
      if (a === 'save') {
        return save({
          analytics: chkAnalytics ? chkAnalytics.checked : false,
          marketing: chkMarketing ? chkMarketing.checked : false,
          preferences: true
        });
      }
    });

    // Reabrir desde el enlace del footer ("Preferencias de cookies")
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cookies-open]')) { e.preventDefault(); show(); }
    });

    var apiRespondio = false;

    withCustomerPrivacy(function (cp) {
      apiRespondio = true;
      // Le decimos al motor de Consent Mode si Shopify YA está midiendo, que es
      // lo único que decide si nuestra etiqueta debe mandar el ping de modelado
      // o callarse para no duplicar al pixel de Shopify. Shopify es el árbitro:
      // en los países sin consentimiento obligatorio su pixel corre desde el
      // primer momento aunque nadie haya tocado el banner.
      var midiendo = false;
      try { midiendo = cp.analyticsProcessingAllowed() === true; } catch (e) {}

      var answer = answeredConsent(cp);
      var mirror = readMirror();

      if (!answer) {
        // Shopify, que es la verdad LEGAL, no tiene registro. Si nuestro espejo
        // decía que sí, está obsoleto y no puede seguir diciéndole a Google que
        // hay permiso: lo retiramos, volvemos a denegado y preguntamos otra vez.
        if (mirror) {
          pushGtagConsent({ analytics: false, marketing: false }, true);
          clearMirror();
        }
      } else {
        // Visitante que vuelve. Los permisos del head se declararon leyendo la
        // cookie espejo; si Shopify dice otra cosa (consentimiento revocado
        // desde otro sitio, una cookie caducada antes que la otra) manda
        // Shopify y reconciliamos las dos capas.
        if (!mirror || !!mirror.a !== answer.analytics || !!mirror.m !== answer.marketing) {
          pushGtagConsent(answer);
          writeMirror(answer);
        }
        // Dejamos las casillas del panel reflejando lo que ya eligió.
        if (chkAnalytics) chkAnalytics.checked = answer.analytics;
        if (chkMarketing) chkMarketing.checked = answer.marketing;
      }

      // Ya con el estado reconciliado, le decimos al motor de Consent Mode si
      // Shopify está midiendo: es lo único que decide si nuestra etiqueta manda
      // el ping de modelado o se calla para no duplicar al pixel de Shopify.
      if (typeof window.__glucodyConfigureGtag === 'function') {
        window.__glucodyConfigureGtag(midiendo);
      }

      if (!answer) show();
    });

    // Red de seguridad. show() vivía SOLO dentro del callback de arriba, y
    // withCustomerPrivacy no hace nada si Shopify no expone customerPrivacy ni
    // loadFeatures, y se calla si loadFeatures devuelve error. En ese escenario
    // el banner no salía, nadie podía aceptar y la tienda se quedaba a cero de
    // medición sin que saltara ningún aviso. Si a los 2 s no ha contestado
    // nadie y el espejo no tiene una respuesta previa, preguntamos igual:
    // save() escribe Google y el espejo ANTES de tocar la API de Shopify, así
    // que el consentimiento se recoge aunque la API siga sin cargar.
    setTimeout(function () {
      if (apiRespondio) return;
      if (readMirror()) return;
      show();
    }, 2000);
  }

  // Shopify emite esto cuando el consentimiento cambia por cualquier vía
  // (nuestro banner, otra app, el checkout). Mantiene Google sincronizado.
  document.addEventListener('visitorConsentCollected', function (e) {
    var c = (e && e.detail) || {};
    var consent = { analytics: c.analyticsAllowed === true, marketing: c.marketingAllowed === true };
    pushGtagConsent(consent);
    writeMirror(consent);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
